import React, { useContext } from 'react';
import { util } from '../../Util';
import CommonContext from '../../Common';

export const PriceDisplay = ({ amount }) => {
    const context = useContext(CommonContext);
    const currencyCode = context?.tenant?.defaultCurrencyCode || 'USD'; 

    const formattedPrice = util.number.formatCurrency(amount, currencyCode);

    return (
        <span>
            {formattedPrice}
        </span>
    );
};
